import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import { withTheme } from '@material-ui/core/styles';
import { TextField as TextFieldComponent } from 'components/TextField/TextField';
import { Select as SelectComponent } from 'components/Select/Select';

export const DialogBase = styled(Dialog)`
  .MuiDialog-paperWidthSm {
    padding: 25px;
    border-radius: 4px;
    max-width: 380px;
  }
`;

export const DialogTitle = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-weight: bold;
  font-size: 20px;
  letter-spacing: 0;
  color: #000;
  height: 24px;
`;

export const DialogContentText = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-weight: medium;
  font-size: 16px;
  padding-top: 15px;
  color: rgba(0, 0, 0, 0.8);
  width: 330px;
`;

export const FormWrapper = styled.div`
  padding-top: 15px;
`;

export const TextField = withTheme(styled(TextFieldComponent)`
  && {
    margin-bottom: ${(props): number => props.theme.spacing(2.5)}px;
    margin-top: ${(props): number => props.theme.spacing(1)}px;
  }
`);

export const DialogActions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
`;

export const ButtonWrapper = styled.div`
  height: 45px;
  margin-left: 10px;
`;

export const SelectContainer = styled.div`
  padding-top: 8px;
  padding-bottom: 4px;
`;

export const SelectWrapper = styled(SelectComponent)`
  min-height: 0px;
  margin-bottom: 15px;
`;
